import { ReferenceDataCaseStatus } from 'rome-library';

export class DirectTaggingViewModel {
  public PageNameParam: string;
  public PageNameParamValuePartial: string;
  public ProductNameParam: string;
  public ProductNameParamValue: string;
  public UserLoginStatusParam: string;
  public ProductVariationParam: string;
  public ProductVariationParamValueResidental: string;
  public ProductVariationParamValueBtl: string;
  public FormNameParam: string;
  public QuoteIdParam: string;
  public TransactionIdParam: string;
  public AccountIdParam: string;
  public AppStageParam: string;
  public AppStageParamValueAip: string;
  public AppStageParamValueApp: string;
  public DecisionParam: string;
  public DecisionParamValueAccept: string;
  public DecisionParamValueDecline: string;
  public DecisionParamValueRefer: string;
  public GoogleVirtualPageViewEventName: string;

  private CaseStatusMap = [];

  public setCaseStatusMap(): void {
    this.CaseStatusMap = [
      {
        appStage: this.AppStageParamValueApp,
        decision: this.DecisionParamValueAccept,
        caseStatuses: [
          ReferenceDataCaseStatus.AppAccepted,
          ReferenceDataCaseStatus.AppAcceptedPendingPayment,
          ReferenceDataCaseStatus.AppReceived,
          ReferenceDataCaseStatus.AppSubmitted,
          ReferenceDataCaseStatus.DeterminingSupportingDocuments,
          ReferenceDataCaseStatus.AwaitingDocuments
        ]
      },
      {
        appStage: this.AppStageParamValueApp,
        decision: this.DecisionParamValueDecline,
        caseStatuses: [ReferenceDataCaseStatus.AppDeclined]
      },
      {
        appStage: this.AppStageParamValueApp,
        decision: this.DecisionParamValueRefer,
        caseStatuses: [ReferenceDataCaseStatus.AppReferred]
      },
      {
        appStage: this.AppStageParamValueAip,
        decision: this.DecisionParamValueAccept,
        caseStatuses: [ReferenceDataCaseStatus.AipAccepted]
      },
      {
        appStage: this.AppStageParamValueAip,
        decision: this.DecisionParamValueDecline,
        caseStatuses: [ReferenceDataCaseStatus.AipDeclined]
      },
      {
        appStage: this.AppStageParamValueAip,
        decision: this.DecisionParamValueRefer,
        caseStatuses: [ReferenceDataCaseStatus.AipReferred]
      }
    ];
  }

  public getSubmissionStatus(caseStatus: string): any {
    this.CaseStatusMap.forEach((statusMap) => {
      statusMap.caseStatuses.forEach((status) => {
        if (status === caseStatus) {
          return statusMap;
        }
      });
    });
  }
}
